export default __webpack_public_path__ + "3f9ee007bb25db571245e87df9d7c19d.svg";